import React from "react";
import { PiStudentBold } from "react-icons/pi";


const StudyCard = ({data}) => {
  return (
    <>
      <div className="degree-content-box">
        <div className="degree-heading-box">
          <h5>{data.college}</h5>
        </div>
        <div className="degree-details-cover text-black">
          <div className="study-icon-box">
            <PiStudentBold />
          </div>
          <p>
            {/* {data.description} */}
            {data.degree}
          </p>
        </div>
      </div>
    </>
  );
};

export default StudyCard;
